import styled from '@mui/material/styles/styled'

export const Label = styled('div')(({ theme }) => ({
  fontFamily: 'Source Sans Pro Semibold',
  color: theme.palette.common.black,
  fontSize: '14px',
}))
